// Bazı okullar (Akbim altyapılı) AES şifreli payload yerine kendi JWT'lerini
// gönderiyor (bkz. ueslms/.claude/notes/sso-platform-yetkilendirme-plani.md — 24.08.2026).
// JWT her zaman 3 parça, nokta ile ayrılmış (header.payload.signature); AES/CryptoJS
// çıktısı ise noktasız tek bir base64 blob'u — bu yüzden ayrım basit ve güvenilir.
//
// Tespit edilirse: ilgili bileşen AES çözmeyi hiç denemez (denerse atob() "." karakteri
// yüzünden hata fırlatır, sayfa sessizce donar), ham sso değerini `sso_jwt` alanıyla
// doğrudan backend'e gönderir. Çözümleme (imza doğrulaması OLMADAN, jwt-decode ile aynı
// güven modeli) ve okul eşleştirmesi (branchId -> UES school_id) sunucuda
// AkbimJwtSsoService'te yapılır.
export function isJwtSso(value) {
  return typeof value === 'string' && (value.match(/\./g) || []).length === 2;
}
